import { FC, useState } from "react";
import { useGetVideoShareLinkQuery } from "../../api/projectsApi";
import ShareOptions from "../../components/ShareOptions/ShareOptions";
import { Span } from "../../components/Text/Text";
import { VersionT } from "../../models/models";
import ReactPlayer from "react-player";
import DownloadIcon from "./components/DownloadIcon";
import { BroadcasterLogo } from "./components/BroadcasterLogo/BroadcasterLogo";
import { LogoClockPreview } from "./components/LogoClockPreview/LogoClockPreview";
import { BroadcastersOverlayPlayerQueryI } from "../../pages/projects/ViewVideoProject/models";
import { safeZone } from "../../assets/images";
import styles from "./videoPlayer.module.scss";
import { useAppSelector } from "../../store/hooks";
import { selectCurrentUser } from "../../store/selectors/authSelectors";
import { AccessLevelE } from "../../models/enums";
import { Link } from "react-router-dom";
import { isMobileOrTablet } from "../../utils/helpers/mediaQueries";

type VideoPlayerPropTypes = {
  item: VersionT;
  broadcastersOverlayPlayerData: BroadcastersOverlayPlayerQueryI
};

const VideoPlayer: FC<VideoPlayerPropTypes> = ({ item:
  {
    Name,
    Id,
    PreviewDownloadUrl,
    DesktopPlaybackUrl,
    fileFormat,
    AdId
  },
  broadcastersOverlayPlayerData }) => {
  const [isLogoVisible, setIsLogoVisible] = useState(false)
  const [isClockVisible, setIsClockVisible] = useState(false)
  const [currentBroadcaster, setCurrentBroadcaster] = useState<{ value: number, label: string } | undefined>()
  const [isSafeZoneVisible, setIsSafeZoneVisible] = useState(false)

  const { data: videoShareLink } = useGetVideoShareLinkQuery(
    { fileId: Id },
    { skip: !Id }
  );

  const defaultBroadcaster = broadcastersOverlayPlayerData?.Broadcasters?.[0] ?
    {
      value: broadcastersOverlayPlayerData?.Broadcasters?.[0]?.Id,
      label: broadcastersOverlayPlayerData?.Broadcasters?.[0]?.Name
    }
    : undefined

  return (
    <div className={styles.videoPlayerWrapper}>
      <div className={styles.title}>
        <Span>Video preview:</Span>
        <span>{Name}</span>
      </div>
      <div className={styles.videoWrapper}>
        {isSafeZoneVisible ? <div className={styles.safeZone}>
          <img src={safeZone} alt="safe zone" />
        </div> : null}
        <LogoClockPreview
          broadcastersOverlayPlayerData={broadcastersOverlayPlayerData}
          currentBroadcaster={currentBroadcaster || defaultBroadcaster}
          hideClock={!isClockVisible}
          hideLogo={!isLogoVisible}
        />
        {/*@ts-ignore*/}
        <ReactPlayer
          url={DesktopPlaybackUrl}
          playing
          controls
          width="100%"
          height="100%"
          playsinline
        />
      </div>
      <div className={styles.buttons}>
        {!isMobileOrTablet() && (
          <BroadcasterLogo
            isLogoVisible={isLogoVisible}
            setIsLogoVisible={setIsLogoVisible}
            isClockVisible={isClockVisible}
            setIsClockVisible={setIsClockVisible}
            broadcastersOverlayPlayerData={broadcastersOverlayPlayerData}
            setCurrentBroadcaster={setCurrentBroadcaster}
            currentBroadcaster={currentBroadcaster || defaultBroadcaster}
            isSafeZoneVisible={isSafeZoneVisible}
            setIsSafeZoneVisible={setIsSafeZoneVisible}
          />
        )}

        <DownloadIcon
          PreviewDownloadUrl={PreviewDownloadUrl}
          fileFormat={fileFormat}
          AdId={AdId}
          Id={Id}
        />
        <ShareOptions
          type="video"
          Id={Id}
          addClassName={styles.shareSectionWrapper}
          videoUrl={videoShareLink}
        />
      </div>
    </div>
  );
};

export default VideoPlayer;
